import { render, staticRenderFns } from "./SpecialBet.vue?vue&type=template&id=ec843b0c&scoped=true&"
import script from "./SpecialBet.vue?vue&type=script&lang=js&"
export * from "./SpecialBet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec843b0c",
  null
  
)

export default component.exports